<template>
	<div class="bottomNav_container">
		<NewsTickerLayout v-if="!displayStore.isDesktop && route.path === '/home' && headerStore.getCountry === 'USA'">
			<VerticalSlider />
		</NewsTickerLayout>
		<nav class="bottomNav" :class="displayStore.isDesktop && 'state-moreMenu'">
			<router-link
				v-for="(item, index) in headerStore.getCountry === 'USA'
					? bottomNavMenuUSAList
					: headerStore.getCountry === 'JPN'
						? bottomNavMenuJPNList
						: bottomNavMenuKRList"
				:key="index"
				:to="item.path"
				:class="{ on: $route.name === item.group }"
				@click="item.path === '' && onClickNotService()"
			>
				<component :is="item.icon" :icon-color="$route.name !== item.group ? '#fff' : '#ff5e00'" />
				<p>{{ item.title }}</p>
			</router-link>
		</nav>
	</div>
</template>

<script setup lang="ts">
// core
import { useRoute } from 'vue-router';

// component
import NewsTickerLayout from '@/components/layout/main/NewsTickerLayout.vue';
import VerticalSlider from '@/components/swiper/VerticalSlider.vue';
import { bottomNavMenuJPNList, bottomNavMenuKRList, bottomNavMenuUSAList } from '@/constants/menu';
// constant
import { COMPANY_TITLE, MESSAGE_PC_MENU_UNDER_PREPARATION } from '@/constants/title';
// store
import { useDisplayStore } from '@/stores/display';
import { useHeaderStore } from '@/stores/header';
import { usePopupStore } from '@/stores/popup';

// -----variable-----
const displayStore = useDisplayStore();
const headerStore = useHeaderStore();
const route = useRoute();
const popupStore = usePopupStore();
// -----function-----

//서비스 준비중이면 해당 내용
const onClickNotService = () => {
	popupStore.openPopup({
		content: COMPANY_TITLE,
		subtext: MESSAGE_PC_MENU_UNDER_PREPARATION,
	});
};
</script>

<style scoped lang="scss">
.bottomNav_container {
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 70;
	width: 100%;
	// height: var(--bottomMenu-height);
	background-color: var(--color-bg);
	color: var(--color-base-white);
	border-top: 1px solid var(--border-color-default);
	box-sizing: border-box;
}
.bottomNav {
	display: flex;
	align-content: center;
	justify-content: center;
	max-width: 960px;
	height: var(--bottomMenu-height);
	margin: 0 auto;
}
.bottomNav a,
.bottomNav button {
	flex-basis: calc(100% / 5);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	padding: 1rem 0;
}
.bottomNav a img,
.bottomNav button img {
	width: 2.4rem;
	height: 2.4rem;
}
.bottomNav a img.on,
.bottomNav button img.on {
	display: none;
}
.bottomNav a p,
.bottomNav button p {
	position: relative;
	font-size: 1.2rem;
	font-weight: var(--font-w-light);
	white-space: nowrap;
}
.bottomNav a p::before,
.bottomNav button p::before {
	content: '';
	opacity: 0;
	display: flex;
	width: 0.6rem;
	margin: 0.2rem auto;
	border-radius: var(--border-radius-full);
	background-color: var(--color-primary);
}
.bottomNav a.on p::before,
.bottomNav button.on p::before {
	opacity: 1;
}
.bottomNav a.on img,
.bottomNav button.on img {
	display: none;
}
.bottomNav a.on img.on,
.bottomNav button.on img.on {
	display: inline-block;
}
.bottomNav a.on p,
.bottomNav button.on p {
	color: var(--color-primary);
}
.sideFix_container {
	position: absolute;
	bottom: 9rem;
	right: calc(var(--space-x-large) - 1rem);
	display: flex;
	flex-direction: column;
	gap: var(--space-small);
}
.sideFix_container .btn_wrap {
	padding: 1rem;
	min-height: unset;
	border-radius: var(--border-radius-full);
	background: rgba(255, 255, 255, 0.9);
}
.sideFix_container .btn_wrap img {
	width: 2.4rem;
	height: 2.4rem;
}
@media screen and (min-width: 1280px) {
	.bottomNav_container {
		display: none;
	}
}

// 더보기 눌렀을 때 다른 탭 off
.state-moreMenu a img {
	display: inline-block !important;
}
.state-moreMenu a p {
	color: white !important;
}
.state-moreMenu a img.on {
	display: none !important;
}
</style>
